(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ps-filtered-reviews"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('ps-filtered-reviews')) {
  customElements.define('ps-filtered-reviews', class extends HTMLElement {
    connectedCallback() {
      this.initFrame = requestAnimationFrame(() => this.init());
    }
    disconnectedCallback() {
      cancelAnimationFrame(this.initFrame);
      cancelAnimationFrame(this.layoutFrame);
      cancelAnimationFrame(this.scrollFrame);
      this.events?.abort();
      this.resizeObserver?.disconnect();
    }
    init() {
      this.events?.abort();
      this.resizeObserver?.disconnect();
      this.events = new AbortController();
      const options = { signal: this.events.signal };
      this.track = this.querySelector('.rfr-track');
      if (!this.track) return;
      this.cards = [...this.querySelectorAll('.rfr-card')];
      this.filters = [...this.querySelectorAll('.rfr-filter')];
      this.dots = this.querySelector('.rfr-dots');
      this.empty = this.querySelector('.rfr-empty');
      this.cards.forEach(card => {
        card.keys = card.dataset.categories.split(',').map(key => key.trim().toLowerCase()).filter(Boolean);
        const initials = card.querySelector('.rfr-initials');
        if (initials && !initials.textContent.trim()) {
          const words = (card.querySelector('.rfr-name')?.innerText || '').trim().split(/\s+/).filter(Boolean);
          initials.textContent = words.length ? words[0][0] + (words.length > 1 ? words[words.length - 1][0] : '') : '';
        }
      });
      this.addEventListener('click', event => {
        const filter = event.target.closest('.rfr-filter');
        if (filter) { this.applyFilter(filter.dataset.key); return; }
        const more = event.target.closest('.rfr-more');
        if (more) {
          const expanded = more.getAttribute('aria-expanded') !== 'true';
          more.setAttribute('aria-expanded', String(expanded));
          more.closest('.rfr-card').classList.toggle('is-expanded', expanded);
          more.querySelector('.rfr-more-label').hidden = expanded;
          more.querySelector('.rfr-less-label').hidden = !expanded;
          this.scheduleLayout();
          return;
        }
        const dot = event.target.closest('.rfr-dot');
        if (dot) this.goTo(Number(dot.dataset.index));
      }, options);
      this.track.addEventListener('scroll', () => {
        cancelAnimationFrame(this.scrollFrame);
        this.scrollFrame = requestAnimationFrame(() => this.updateActiveDot());
      }, { ...options, passive: true });
      this.track.addEventListener('keydown', event => {
        if (event.target !== this.track) return;
        let target = this.activePage || 0;
        if (event.key === 'ArrowRight') target++;
        else if (event.key === 'ArrowLeft') target--;
        else if (event.key === 'Home') target = 0;
        else if (event.key === 'End') target = this.offsets.length - 1;
        else return;
        event.preventDefault();
        this.goTo(target);
      }, options);
      this.addEventListener('shopify:block:select', event => {
        const id = event.detail?.blockId;
        const filter = this.filters.find(item => item.dataset.blockId === id);
        if (filter) { this.applyFilter(filter.dataset.key); return; }
        const card = this.cards.find(item => item.dataset.blockId === id);
        if (!card) return;
        const matching = this.filters.find(item => card.keys.includes(item.dataset.key));
        this.applyFilter(matching?.dataset.key || '');
        requestAnimationFrame(() => {
          this.track.scrollTo({left:card.offsetLeft - this.visibleCards[0].offsetLeft,behavior:'instant'});
        });
      }, options);
      this.resizeObserver = new ResizeObserver(() => this.scheduleLayout());
      this.resizeObserver.observe(this.track);
      window.addEventListener('resize', () => this.scheduleLayout(), options);
      document.fonts?.ready.then(() => { if (this.isConnected) this.scheduleLayout(); });
      this.applyFilter(this.filters[0]?.dataset.key || '');
      this.dataset.ready = 'true';
    }
    applyFilter(key) {
      this.activeKey = key;
      this.filters.forEach(filter => filter.setAttribute('aria-pressed', String(filter.dataset.key === key)));
      this.cards.forEach(card => {
        card.hidden = Boolean(key) && !card.keys.includes(key);
        const tag = card.querySelector('.rfr-tag');
        const category = this.filters.find(filter => filter.dataset.key === key) || this.filters.find(filter => card.keys.includes(filter.dataset.key));
        tag.textContent = tag.dataset.override || category?.dataset.label || '';
        tag.hidden = !tag.textContent.trim();
      });
      this.visibleCards = this.cards.filter(card => !card.hidden);
      this.empty.hidden = this.visibleCards.length > 0;
      this.track.hidden = this.visibleCards.length === 0;
      this.track.scrollTo({left:0,behavior:'instant'});
      this.querySelector('.rfr-status').textContent = this.filters.find(filter => filter.dataset.key === key)?.dataset.label || '';
      this.layout();
    }
    scheduleLayout() {
      cancelAnimationFrame(this.layoutFrame);
      this.layoutFrame = requestAnimationFrame(() => this.layout());
    }
    layout() {
      if (!this.isConnected || !this.visibleCards) return;
      const lines = Number(getComputedStyle(this).getPropertyValue('--rfr-current-lines').trim());
      this.visibleCards.forEach(card => {
        const quote = card.querySelector('.rfr-quote');
        const button = card.querySelector('.rfr-more');
        quote.classList.toggle('rfr-unclamped', lines === 0);
        button.hidden = lines === 0 || (!card.classList.contains('is-expanded') && quote.scrollHeight <= quote.clientHeight + 1);
      });
      const max = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
      const pageSize = matchMedia('(min-width:990px)').matches ? 4 : 1;
      const offsets = [0];
      const origin = this.visibleCards[0]?.offsetLeft || 0;
      for (let i = pageSize; i < this.visibleCards.length; i += pageSize) {
        const offset = Math.min(max, this.visibleCards[i].offsetLeft - origin);
        if (offset > offsets[offsets.length - 1] + 1) offsets.push(offset);
      }
      this.offsets = offsets;
      this.dots.hidden = offsets.length <= 1;
      if (this.dots.children.length !== offsets.length) {
        const fragment = document.createDocumentFragment();
        offsets.forEach((_, index) => {
          const button = document.createElement('button');
          button.type = 'button';
          button.className = 'rfr-dot';
          button.dataset.index = index;
          button.setAttribute('aria-label', (this.dataset.pageLabel || 'Review page') + ' ' + (index + 1));
          fragment.append(button);
        });
        this.dots.replaceChildren(fragment);
      }
      this.updateActiveDot();
    }
    goTo(index) {
      index = Math.max(0, Math.min(this.offsets.length - 1, index));
      this.track.scrollTo({left:this.offsets[index],behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'instant':'smooth'});
    }
    updateActiveDot() {
      if (!this.offsets) return;
      this.activePage = this.offsets.reduce((best, value, i) => Math.abs(value - this.track.scrollLeft) < Math.abs(this.offsets[best] - this.track.scrollLeft) ? i : best, 0);
      [...this.dots.children].forEach((dot, i) => dot.setAttribute('aria-current', String(i === this.activePage)));
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ps-ingredients"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('ps-ingredients')) {
  customElements.define('ps-ingredients', class extends HTMLElement {
    connectedCallback() {
      this.initFrame = requestAnimationFrame(() => { if (this.isConnected) this.initialize(); });
    }
    initialize() {
      this.controller?.abort();
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.track = this.querySelector('[data-ingredient-track]');
      this.cards = Array.from(this.querySelectorAll('[data-ingredient-card]'));
      this.nav = this.querySelector('[data-ingredient-nav]');
      this.prev = this.querySelector('[data-ingredient-prev]');
      this.next = this.querySelector('[data-ingredient-next]');
      this.status = this.querySelector('[data-ingredient-status]');
      this.breakpoint = matchMedia('(min-width:1000px)');
      this.reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
      this.index = 0;
      this.size = this.breakpoint.matches ? 8 : 4;
      this.regroup();
      this.prev.addEventListener('click', () => this.go(this.index - 1), options);
      this.next.addEventListener('click', () => this.go(this.index + 1), options);
      this.track.addEventListener('scroll', () => {
        cancelAnimationFrame(this.scrollFrame);
        this.scrollFrame = requestAnimationFrame(() => this.sync());
      }, options);
      this.track.addEventListener('keydown', event => {
        if (event.target !== this.track || !['ArrowLeft','ArrowRight','Home','End'].includes(event.key)) return;
        event.preventDefault();
        const rtl = getComputedStyle(this.track).direction === 'rtl';
        const direction = (event.key === 'ArrowRight' ? 1 : -1) * (rtl ? -1 : 1);
        this.go(event.key === 'Home' ? 0 : event.key === 'End' ? this.pages.length - 1 : this.index + direction);
      }, options);
      this.breakpoint.addEventListener('change', () => this.regroup(), options);
      this.addEventListener('shopify:block:select', event => {
        const card = event.target.closest('[data-ingredient-card]');
        const index = this.cards.indexOf(card);
        if (index >= 0) this.go(Math.floor(index / this.size), true);
      }, options);
      this.resizeObserver = new ResizeObserver(() => this.go(this.index, true));
      this.resizeObserver.observe(this.track);
    }
    regroup() {
      const anchor = this.index * this.size;
      this.size = this.breakpoint.matches ? 8 : 4;
      const fragment = document.createDocumentFragment();
      this.pages = [];
      for (let i = 0; i < this.cards.length; i += this.size) {
        const page = document.createElement('div');
        page.className = 'psi-page';
        page.dataset.ingredientPage = '';
        this.cards.slice(i, i + this.size).forEach(card => page.append(card));
        fragment.append(page);
        this.pages.push(page);
      }
      this.track.replaceChildren(fragment);
      this.track.dataset.ready = '';
      this.nav.hidden = this.pages.length <= 1;
      this.go(Math.floor(anchor / this.size), true);
    }
    go(index, instant = false) {
      this.index = Math.max(0, Math.min(index, this.pages.length - 1));
      const target = this.pages[this.index];
      if (target) {
        const left = target.getBoundingClientRect().left - this.track.getBoundingClientRect().left + this.track.scrollLeft;
        this.track.scrollTo({ left, behavior: instant || this.reducedMotion.matches ? 'instant' : 'smooth' });
      }
      this.update();
    }
    sync() {
      if (!this.pages.length) return;
      const trackLeft = this.track.getBoundingClientRect().left;
      const offsets = this.pages.map(page => Math.abs(page.getBoundingClientRect().left - trackLeft));
      this.index = offsets.indexOf(Math.min(...offsets));
      this.update();
    }
    update() {
      this.prev.disabled = this.index === 0;
      this.next.disabled = this.index >= this.pages.length - 1;
      this.status.textContent = this.pages.length ? (this.index + 1) + ' / ' + this.pages.length : '';
      this.pages.forEach((page, index) => {
        page.inert = index !== this.index;
        page.setAttribute('aria-hidden', String(index !== this.index));
      });
    }
    disconnectedCallback() {
      cancelAnimationFrame(this.initFrame);
      this.controller?.abort();
      this.resizeObserver?.disconnect();
      cancelAnimationFrame(this.scrollFrame);
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
